import {
  navLinks,
  whatsappUrl,
  instagramUrl,
  contactEmail,
  contactPhone,
  contactAddress,
} from "@/mocks/serra";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-bg border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Logo className="w-9 h-9" />
              <span className="font-semibold text-white">Serra Consultoria</span>
            </div>
            <p className="text-white/45 text-sm leading-relaxed max-w-xs">
              Posicionamos empresas para vender mais através da tecnologia.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href={instagramUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/60 hover:text-orange hover:border-orange transition-colors"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 text-white/60 hover:text-orange hover:border-orange transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-mono-tech tracking-[0.2em] uppercase text-white/40 mb-5">
              Mapa do Site
            </h4>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-mono-tech tracking-[0.2em] uppercase text-white/40 mb-5">
              Contato
            </h4>
            <div className="flex flex-col gap-3 text-sm">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                {contactPhone}
              </a>
              <a
                href={`mailto:${contactEmail}`}
                className="text-white/60 hover:text-white transition-colors cursor-pointer break-all"
              >
                {contactEmail}
              </a>
              <p className="text-white/40 leading-relaxed">{contactAddress}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-center">
          <p className="text-white/35 text-xs">
            © {new Date().getFullYear()} Serra Consultoria e Tecnologia. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
